import React from "react";
import IataFailedRecord from "./iata-failed-record";
import IataCompletedRecord from "./iata-completed-record";
import IataPendingdRecord from "./iata-pending-record";

class IATATimelineItem extends React.Component {
    render() {
        const { item, fetchCallBack } = this.props;
         return (
            <div>
                <div className='timeline-boxes-w'>
                     { (item.Status === 'Completed') &&
                         <IataCompletedRecord report={item} fetchCallBack={fetchCallBack} trackDownload={this.trackFileDownload} />
                     }
                    {
                        ((item.Status !== 'Completed') && (item.Status !== 'Processing'))
                        && <IataFailedRecord report={item}/>
                    }
                    {
                        (item.Status === 'Processing') &&
                        <IataPendingdRecord report={item}/>
                    }
                </div>
            </div>
        )
    }
}
export default IATATimelineItem;


// WEBPACK FOOTER //
// ./src/views/iata/timeline-item.js